import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "titre",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Titre"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "anneePublication",
  class: "form-label"
}, [
  /*#__PURE__*/_createTextVNode("Année Publication"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Catégorie "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_11 = {
  key: 0,
  class: "text-danger"
}
const _hoisted_12 = { class: "col-md-6" }
const _hoisted_13 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Maison d'Edition "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_15 = { class: "col-md-12 d-flex flex-column mt-3" }
const _hoisted_16 = { class: "d-flex align-items-center" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-success me-3",
  type: "submit"
}, " Modifier Inscription ", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "position-relative" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "inscriptionForm",
        onSubmit: _ctx.editInscription,
        "validation-schema": _ctx.inscriptionSchema,
        "initial-values": _ctx.inscriptionForm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createVNode(_component_Field, {
                name: "titre",
                class: "form-control",
                type: "text"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "titre",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createVNode(_component_Field, {
                name: "anneePublication",
                class: "form-control",
                type: "text"
              }),
              _createVNode(_component_ErrorMessage, {
                name: "anneePublication",
                class: "text-danger"
              })
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  name: "categorie",
                  modelValue: _ctx.categories,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.categories) = $event)),
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.categorieOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner la catégorie",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.showMErr)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, "La catégorie est obligatoire"))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createVNode(_component_Field, {
                  name: "maisonEdition",
                  type: "text"
                }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, _mergeProps({
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event)
                    }, field, {
                      options: _ctx.maisonEditionOptions,
                      "preserve-search": true,
                      multiple: false,
                      searchable: true,
                      placeholder: "Sélectionner la maison d'Edition",
                      label: "label",
                      "track-by": "label"
                    }), null, 16, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "maisonEdition",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createVNode(_component_router_link, {
                  to: "/inscriptions/liste-inscription",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => [
                    _hoisted_18,
                    _hoisted_19,
                    _createTextVNode("Annuler")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema", "initial-values"])
    ])
  ]))
}